import { setLandingPageData } from './actions';
import { getBuyerLandingPage } from '@/services/buyer-dashboard';
import { Dispatch } from 'redux';
import { IState } from '@/state/IState';

// export const getProjectData = async (dispatch, profileId) => {
//     const data = await getProjectDataFromProfile(profileId);
//     dispatch(setProjectData(data));
// };

export const loadLandingPage = (residentialUnitId?: number | null) => {
    return async function(dispatch: Dispatch, getState: () => IState): Promise<any> {
        if (residentialUnitId === null) residentialUnitId = getState().buyer.permissions!.residentialUnitId;


        if (residentialUnitId) {
            const data = await getBuyerLandingPage(residentialUnitId);
            return dispatch(setLandingPageData(data));
        }
    };
};

